<div class="table-container">

  <div
    *ngIf="cikTransactions.length > 0"
    [@simpleFadeAnimation]="ready ? 'fadeIn': 'fadeOut'"
  >
    <div class="header">
      <h4>{{message}}</h4>
    </div>
    <table>
      <thead>
        <tr>
          <td>Date</td>
          <td>Traded by</td>
          <td>Relation</td>
          <td>Total value ($)</td>
          <td>Date filed</td>
        </tr>
      </thead>
      <tbody *ngFor="let transaction of cikTransactions;let i = index">
        <tr
          class="cik-row"
          (click)="rowClicked(transaction)"
          [ngStyle]="{'color': transaction.transactionCode == 'P' ? '#349324' : 'red' }"
          [ngClass]="{'bg-even': 0 === i % 2}"
        >
          <td>
            {{dtService.monthAndDay(transaction.transactionDate)}}</td>
          <td>
            {{transaction.reportingOwner}}</td>
          <td [innerHtml]="
          getRelations(transaction)">
          </td>
          <td>
            {{transaction.transactionValue.toString().replace('-','')  | comma }}
          </td>
          <td class="filing-date-cell">{{dtService.monthAndDay(transaction.updated)}}</td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td [ngStyle]="{ 'background-color': totalCIKPos ? 'green' : 'red' }">
          </td>
          <td [ngStyle]="{ 'background-color': totalCIKPos ? 'green' : 'red' }">
          </td>
          <td
            style="color:white;font-weight:bold;text-align:right;"
            [ngStyle]="{ 'background-color': totalCIKPos ? 'green' : 'red' }"
          >
            Difference
          </td>
          <td
            style="font-weight:bold;"
            [ngStyle]="{ 'color': totalCIKPos ? 'green' : 'red' }"
          >
            {{totalCIK}}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
